import { useIsBusy } from '../hooks/index.js'

/** Simple wrapper to set busy in Redux on load */
export const SuspenseBusy = () => {
  useIsBusy(true)
  return null
}

export default SuspenseBusy
